import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.panel_background,
    overflow: 'hidden'
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, { ...theme.cardStyles.outlined, margin: 0, width: '100%' })
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  coverageContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  coverageLabel: {
    marginBottom: theme.spacing(2)
  },
  errorMessage: {
    color: theme.colorPalette.red_50,
    marginTop: theme.spacing(1)
  }
});

export default makeStyles(styles);
